var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    ref: "seal",
    staticClass: "seal",
    style: {
      left: _vm.myLeft + "px",
      top: _vm.myTop + "px",
      width: _vm.maxWidth * 0.21 + "px",
      height: _vm.maxWidth * 0.21 + "px",
      "background-image": "url(" + _vm.src + ")"
    },
    attrs: { src: require("../assets/tm.png"), alt: "" },
    on: {
      mousedown: function($event) {
        $event.stopPropagation()
        $event.preventDefault()
        return _vm.mousedown($event)
      },
      mouseup: function($event) {
        return _vm.mouseup($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }